import { useCallback } from "react";

const useCopyLink = () => {
  const handleCopyLink = useCallback((taskId, onSuccess, onError) => {
    let url = window.location.href;
    const urlObj = new URL(url);
    const pathSegments = urlObj.pathname.split("/");

    const currentView = pathSegments[pathSegments.length - 1];
    const viewsToReplace = ["assignedtome", "overduetasks", "completedtasks"];

    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

    if (viewsToReplace.includes(currentView) || uuidRegex.test(currentView)) {
      pathSegments[pathSegments.length - 1] = "activetasks";
      urlObj.pathname = pathSegments.join("/");
    }

    const searchParams = new URLSearchParams(urlObj.search);
    if (!searchParams.has("taskId")) {
      searchParams.append("open", taskId);
      urlObj.search = searchParams.toString();
    }

    navigator.clipboard
      .writeText(urlObj.toString())
      .then(() => {
        if (onSuccess) onSuccess();
      })
      .catch(() => {
        if (onError) onError();
      });
  }, []);

  return { handleCopyLink };
};

export default useCopyLink;
